"use strict";

exports.__esModule = true;
exports.forceReflow = void 0;

var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};

exports.forceReflow = forceReflow;


//////////////////
// WEBPACK FOOTER
// ./~/react-transition-group/cjs/utils/reflow.js
// module id = 672
// module chunks = 0